import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

import "../Styles/index.css";
import "./IntranetRedTheme.css";

import LayoutComunicacion from "./comunicacion/LayoutComunicacion";

export default function IntranetComunicacionAvisosPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const initialItem = location.state?.initialItem;

    const handleNavigate = (target, item = null) => {
        navigate(`/menu/intranet/comunicacion/${target}`, { state: { initialItem: item } });
    };

    return (
        <div className="intranet-red-theme">
            <LayoutComunicacion activeScreen="avisos" activeItem={initialItem} onNavigate={handleNavigate} />
        </div>
    );
}
